import { AppointmentDetails } from 'store/booking/types';

export function bookingAppointmentCallEventProps(
  appointmentDetails: AppointmentDetails,
  additionalEventProps?: Object
) {
  const doctor = appointmentDetails?.doctor || {};

  return {
    clinical_specialty_name:
      appointmentDetails?.groupedVisitType?.visitTypes?.[0]?.specialty?.nameLong ||
      appointmentDetails?.specialty?.nameLong ||
      '',
    clinical_visit_name:
      appointmentDetails?.groupedVisitType?.visitTypes?.[0]?.appointmentNameInCerner ||
      appointmentDetails?.groupedVisitType?.visitTypes?.[0]?.synonymDisplay ||
      '',
    facility_name: appointmentDetails?.appointmentLocation?.locationName || '',
    provider_name: doctor?.displayName || '',
    provider_specialty: doctor?.specialties?.[0]?.specialtyName || doctor?.primarySpecialty || '',
    type_of_appointment: appointmentDetails?.groupedVisitType?.name || '',
    type_of_location: appointmentDetails?.appointmentType || '',
    ...additionalEventProps
  };
}
